<template>
    <div class="menu">
        <img src="../assets/logo.png" class="logo">
        <div class="menu-box">
            <div :class="step == 1 ? 'select' : ''" @click="selectMenu(1)">HOME </div>
            <div :class="step == 2 ? 'select' : ''" @click="selectMenu(2)">PRODUCT LIST</div>
            <div :class="step == 3 ? 'select' : ''" @click="selectMenu(3)">SHOP</div>
            <div :class="step == 4 ? 'select' : ''" @click="selectMenu(4)">CONTACT US</div>
        </div>
    </div>
</template>
<script>
export default {
    name: "Menu",
    props: {
        step: {
            type: Number,
            default: 1
        }
    },
    data() {
        return {
            index: 0
        };
    },
    methods: {
        selectMenu(value) {
            this.index = value
            if (value == this.step) {
                return
            }
            switch (value) {
                case 1: this.$router.push({ path: "/" }); break;
                case 2: this.$router.push({ path: "Product" }); break;
                case 3: this.$router.push({ path: "Shop" }); break;
                case 4: this.$router.push({ path: "ContactUs" }); break;
                // case 5: this.$router.push({ path: "aboutUs" }); break;
                // case 5: this.$router.push({ path: "cooperate" }); break;
                default: this.$router.push({ path: "/" }); break;
            }
        }
    }
}
</script>
<style lang="less" scoped>
.menu {
    padding: 10px 360px;
    background: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .logo {
        // width: 242px;
        height: 40px;
    }

    .menu-box {
        display: flex;
        width: 500px;
        line-height: 56px;
        justify-content: space-between;
        font-size: 18px;
        font-weight: 500;
        color: #333333;
        cursor: pointer;
    }

    .select {
        color: #3E8359;
        border-bottom: 4px solid #3E8359;
        font-weight: bolder;
    }
}
</style>